<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="../../../assets/img/loader.webp">
</div>
<div class="content-bg-wrap landing-pa1ge ">
</div>
<div class="contai1ner">
    <div class="row">
        <div class="col-12">
<!-- Header Standard Landing  -->
<div class="header--standar1d header--standard-landing pull-left" style="margin-left:0px; position: relative;"  id="header--standard">
    <div class="contai1ner">
        <div class="header--standard-wrap">
            <a href="javascript:void(0);" class="logo">
                <div class="img-wrap mt-1">
                    <img class="img-fluid" src="../../../assets/../../../assets/img/logo.webp" alt="Football Families">
                </div>
                <div class="title-block">
                    <h6 class="logo-title" style="font-size: 1.6rem;"> Football Family </h6>
                </div>
            </a>
        </div>
    </div>
</div></div>

        <div class="col-12 col-lg-12">
<!-- ... end Header Standard Landing  -->
<div class="header-sp1acer--stand1ard"></div>

<div class="conta1iner">
    <div class="row display-flex" style="padding-top: 20px;">
        
        <div class="col col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
            <div class="landing-content" style="padding: 20px;">
                <h3 style="font-weight:100;">Welcome to Football Family World</h3>
                <p style=" font-weight: 500; background-color: #ffffff81; padding: 10px; border-radius: 10px; display: none;">
                    <span style="color:#202020; font-size: 22px">Register with us and get your privileges:</span><br><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">1-</span>  Participate in the vote and win awards and cash with us.</span><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">2-</span>  Your favorite player you voted him, will be the one who will give you awards.</span><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">3-</span>  Preference for the fastest first 10 votes at the level of each country.</span><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">4-</span>  Communicate with your favorite player via video call ( <span style="color: #336699;"><i class="fad fa-video"></i>&nbsp;Communicator</span> ).</span><br>
                </p>
                <h3 style="font-weight:100;">Football Family have the advantage of being a comprehensive social media platform.</h3>
                <a data-toggle="tab" routerLink="/register" role="tab"
                    class="btn btn-md btn-bor1der register c-white" style="background-color: #202020; color:#fff"> <i class="fad fa-user-plus" style="color:#fff;"></i>&nbsp;Register
                    Now!</a>
            </div>
        </div>
        <div class="col col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
            <!-- Login-Registration Form  -->

            <div class="registration-login-form">
                <div *ngIf="errorFlag" class="alert alert-danger" role="alert">
                    {{message}}

                    <div *ngIf="message === 'Please Activate your account'" (click)="resendEmail()" class="activate"
                        role="alert">
                        <span *ngIf="isActivatedVisible"> {{'Click here For Activation'}} </span>
                    </div>
                </div>


                <!-- Nav tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item ">
                        <a class="nav-link" data-toggle="tab" routerLink="/login" role="tab" style="background-color: #336699;">
                            <i class="fad fa-user-lock" style="color:#fff;"></i>
                        </a>
                    </li>
                    <li class="nav-item ">
                        <a class="nav-link active" data-toggle="tab" routerLink="/register" role="tab" style="background-color: #202020;">
                            <i class="fad fa-user-plus" style="color:#fff;"></i>
                        </a>
                    </li>

                </ul>

                <!-- Tab panes -->
                <div class="tab-content">
                    <div class="tab-pane active" id="profile" role="tabpanel" data-mh="log-tab">
                        <div class="title h3" style="background-color:#336699; color:#fff; font-weight: 600;">Login to your Account</div>
                        <form [formGroup]="loginForm" (ngSubmit)="login()" class="content">
                            <div class="row">
                                <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="h1" style="text-align: center; font-size: 100px;"><i class="fad fa-user-circle" style="color:#bb690c;"></i></div>
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">Your Email
                                            <span style="color: red;"> * </span></label>
                                        <input type="text" formControlName="email" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                            <div *ngIf="f.email.errors.required">email is required</div>
                                        </div>

                                    </div>
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">Your Password
                                            <span style="color: red;"> * </span></label>
                                        <input type="password" formControlName="password" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                            <div *ngIf="f.password.errors.required">Password is required</div>
                                        </div>
                                    </div>

                                    <div class="remember">
                                        <!-- <div class="checkbox">
                                            <label>
                                                <input name="optionsCheckboxes" type="checkbox">
                                                Remember Me
                                            </label>
                                        </div> -->

                                        <a routerLink="/login" class="forgot" data-toggle="modal"
                                            data-target="#restore-password">Forgot my Password</a>
                                    </div>

                                    <button style="font-size: 18px; background-color: #336699;" class="btn btn-prima1ry fu1ll-width">
                                        <i class="fad fa-sign-in"></i>&nbsp;Login
                                    </button>
                                    <hr>
                                    <p class="customStyle">Don’t you have an account? <a routerLink="/register">Register
                                            Now!</a> it’s really simple and you can start enjoying all the benefits!</p>
                                            
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- ... end Login-Registration Form  -->
        </div>
        
    </div>
</div>
<div class="col-12 col-lg-6">
<!-- Window-popup Restore Password -->

<div class="modal fade" id="restore-password" tabindex="-1" role="dialog" aria-labelledby="restore-password"
    aria-hidden="true">
    <div class="modal-dialog window-popup restore-password-popup" role="document">
        <div class="modal-content">
            <a routerLink="/login" class="close icon-close" data-dismiss="modal" aria-label="Close">
                <svg class="olymp-close-icon">
                    <use xlink:href="../../../assets/svg-icons/sprites/icons.svg#olymp-close-icon"></use>
                </svg>
            </a>

            <div class="modal-header" style="background-color:#336699; color:#fff; font-weight: 600;">
                <h6 class="title" style="color:#fff"><i class="fad fa-window-restore"></i>&nbsp;Restore your Password</h6>
            </div>

            <div class="modal-body">
                <form [formGroup]="forgotForm" (ngSubmit)="forgotPassword()">
                    <p>Enter your email and click the send code button. You’ll receive a code in your email. Please use
                        that code below to change the old password for a new one.
                    </p>
                    <div class="form-group label-floating">
                        <label class="control-label" style="font-size: 1rem;">Your Email <span style="color: red;"> *
                            </span></label>
                        <input class="form-control" placeholder="" formControlName="email" type="email" value=""
                            [ngClass]="{ 'is-invalid': submitted && fP.email.errors }">
                        <!-- <div *ngIf="submitted && fP.email.errors" class="invalid-feedback">
                            <div *ngIf="fP.email.errors.required">email is required</div>
                        </div> -->
                    </div>
                    <div *ngIf="errorMessage != ''" class="alert alert-danger" role="alert">
                        {{errorMessage}}
                    </div>
                    <button class="btn btn-purple full-width" style="background-color:#336699; color:#fff">
                        <i class="fad fa-paper-plane"></i>&nbsp;Send me the Code
                    </button>
                </form>

            </div>
        </div>
    </div>
</div>
</div>
</div>
</div>
</div>